module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_305594.25f62b79.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetAlTFF/FormatoSimplificado_305594.pdf
// module id = 329
// module chunks = 0